module.exports = __webpack_public_path__ + "media/images/mail_template/print-f26c9bee0046d78d089f39189ba9c546.png";